module.exports = __webpack_public_path__ + "img/EmailSuccess.b7382bd2.svg";